import Vue from "vue";
import VueRouter from "vue-router";

import ApplicationFormBuilder from "./components/agents/builder/ApplicationForm";

Vue.use(VueRouter);

const routes = [
{
    path: "/application-form/:agencyID/:profileID",
    component: ApplicationFormBuilder,
    name: "Application Form Builder",
}
];

export default new VueRouter({ mode: "history", routes });



// WEBPACK FOOTER //
// ./src/router.js